import { render } from "./LessonsKanban.vue?vue&type=template&id=6f7e7274&scoped=true"
import script from "./LessonsKanban.vue?vue&type=script&lang=js"
export * from "./LessonsKanban.vue?vue&type=script&lang=js"

import "./LessonsKanban.vue?vue&type=style&index=0&id=6f7e7274&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7e7274"]])

export default __exports__